import CreateForwardingDirectiveEntryFormStepCompleted from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStepCompleted'
import { establishmentChoiceEntryOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/establishmentChoiceEntry/establishmentChoiceEntryOptions.constant'
import {
  MaintenanceForwardingsDirectiveFromSteps,
  MaintenanceForwardingsEstablishmentChoiceEntryStepOptions,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { EstablishmentChoiceEntryValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/schemas/maintenanceForwardingDirectiveSteps.schema'
import { MaintenanceForwardingsDirectiveFormStepProps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwardingsDirectiveFormStep.type'
import { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

const EstablishmentChoiceEntryFormStepCompleted = ({
  stepIndex,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.EstablishmentChoiceEntry>) => {
  const { control } = useFormContext<EstablishmentChoiceEntryValidationSchema>()

  const { establishment_choice_entry_type: watchEstablishmentChoiceEntryType } = useWatch({
    control,
  })

  const EntryOptionComponent = useMemo(() => {
    if (watchEstablishmentChoiceEntryType) {
      const establishmentChoiceOption =
        establishmentChoiceEntryOptions[
          watchEstablishmentChoiceEntryType as MaintenanceForwardingsEstablishmentChoiceEntryStepOptions
        ]

      return establishmentChoiceOption.components.completed
    }

    return null
  }, [watchEstablishmentChoiceEntryType])

  return (
    <CreateForwardingDirectiveEntryFormStepCompleted
      stepIndex={stepIndex}
      title="Método de escolha do estabelecimento"
      body={
        EntryOptionComponent && (
          <div>
            <EntryOptionComponent />
          </div>
        )
      }
    />
  )
}

export default EstablishmentChoiceEntryFormStepCompleted
